import { FetchPurchaseMotionRequestTypes } from '../actions/PurchaseMotionActions';
const initialState = {};

const PurchaseMotionsByLocation = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchPurchaseMotionRequestTypes.RECEIVE:
      return payload.data;

    default:
      return state;
  }
};

export default PurchaseMotionsByLocation;